<template>
  <div class="member">
    <div class="my_swipe">
      <van-swipe
        class="my-swipe"
        :autoplay="3000"
        vertical
        :show-indicators="false"
      >
        <van-swipe-item
          class="swipe_item"
          v-for="(item, index) in swiper"
          :key="index"
        >
          <img :src="item.img" />
          <div>{{ item.name }}</div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="grade">
      <img src="../../assets/images/member_grade.png" />
    </div>
    <div class="list">
      <van-radio-group v-model="level_id">
        <div
          :class="item.id == level_id ? 'item active' : 'item'"
          v-for="(item, index) in list"
          :key="index"
          @click="select(item.id, index)"
        >
          <van-radio class="radio" :name="item.id" checked-color="#ff410a">
          </van-radio>
          <div class="items">
            <div class="item_left">
              <div class="left_top">{{ item.name }}</div>
              <div class="left_bottom">
                已使用<span>{{ item.discount }}</span
                >元红包
              </div>
            </div>
            <div class="item_right">
              <div class="ac" v-if="item.id == 4">所有功能<br />永久使用</div>
              <div v-if="item.id == 3"><span>0.3</span>元/天</div>
              <div v-if="item.id == 2"><span>0.5</span>元/天</div>
              <div v-if="item.id == 1"><span>0.9</span>元/天</div>
            </div>
          </div>
        </div>
      </van-radio-group>
    </div>
    <div class="btn">
      <div class="ds">
        已减红包<span>{{ grade.discount }}</span
        >元
      </div>
      <div class="sub" @click="pay">
        微信支付<span>{{ grade.money }}</span
        >元
      </div>
    </div>
  </div>
</template>

<script>
import { getLevelGrade, postLevelPay } from "@api/lcapi";
import { RadioGroup, Radio, Swipe, SwipeItem, Toast } from "vant";
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";
export default {
  name: "Member",
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  data() {
    return {
      list: "", //会员等级列表
      level_id: "", // 会员等级ID
      grade: "",
      swiper: [
        {
          img: require("../../assets/images/ava1 (1).png"),
          name: "陈阳正在追踪客户"
        },
        {
          img: require("../../assets/images/ava1 (2).png"),
          name: "璀璨星空上周添加了 11 个客户"
        },
        {
          img: require("../../assets/images/ava1 (3).png"),
          name: "哦哦哦刚刚追踪到一个客户"
        },
        {
          img: require("../../assets/images/ava1 (4).png"),
          name: "天津市张...上周锁定了7个客户"
        },
        {
          img: require("../../assets/images/ava1 (5).png"),
          name: "薄阑5分钟前添加了一个客户"
        }
      ]
    };
  },
  mounted() {
    this.getLevelGrade();
  },
  methods: {
    /**
     * 获取会员等级
     */
    getLevelGrade() {
      getLevelGrade().then(res => {
        this.list = res.data.list;
        this.level_id = res.data.list[0].id;
        this.grade = res.data.list[0];
      });
    },
    /**
     * 选择
     */
    select(id, index) {
      this.level_id = id;
      this.grade = this.list[index];
    },
    /**
     * 微信支付
     */
    pay() {
      postLevelPay({ level_id: this.level_id })
        .then(res1 => {
          console.log(res1.data.result.jsConfig);
          switch (res1.data.status) {
            case "ORDER_EXIST":
            case "EXTEND_ORDER":
            case "PAY_DEFICIENCY":
            case "PAY_ERROR":
              Toast(res1.msg);
              break;
            case "SUCCESS":
              Toast(res1.msg);
              break;
            case "WECHAT_H5_PAY":
              Toast(res1.msg);
              break;
            case "WECHAT_PAY":
              console.log("WECHAT_PAY，唤起微信");
              pay(res1.data.result.jsConfig)
                .finally(() => {
                  Toast("支付成功!!!!!");
                  setTimeout(function() {
                    window.location.href = "/kehu/index";
                  }, 1200);
                })
                .catch(err => {
                  Toast("支付失败");
                });
              console.log("唤醒微信支付");
          }
        })
        .catch(err => {
          console.log("err1:", err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.member {
  min-height: 100vh;
  padding-bottom: 1.2rem;
  .my_swipe {
    padding: 0.2rem 0.2rem 0 0.2rem;
    background: #ffffff;
    .my-swipe {
      height: 0.8rem;
      border-radius: 1.6rem;
      background: #e3e3e3;
      overflow: hidden;
      .swipe_item {
        height: 0.8rem;
        display: flex;
        align-items: center;
        padding: 0 0.3rem;
        img {
          width: 0.6rem;
          height: 0.6rem;
        }
        div {
          padding-left: 0.15rem;
          font-size: 0.24rem;
          color: #666666;
          letter-spacing: 0.03rem;
        }
      }
    }
  }

  .grade {
    width: 100%;
    padding: 0.2rem;
    background: #ffffff;
    img {
      width: 100%;
    }
  }
  .list {
    background: #ffffff;
    padding: 0.2rem 0.3rem;
    margin-top: 0.2rem;
    .item {
      border: 1px solid #e6e6e6;
      border-radius: 0.16rem;
      margin-top: 0.2rem;
      padding: 0.2rem 0.3rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:first-child {
        margin-top: 0;
      }
      .items {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 0.1rem;
        .item_left {
          flex: 1;
          border-right: 1px dashed #666666;
          .left_top {
            font-size: 0.3rem;
            font-weight: bold;
            color: #836339;
          }
          .left_bottom {
            font-size: 0.24rem;
            color: #999999;
            span {
              color: #ff410a;
              margin: 0 0.05rem;
            }
          }
        }
        .item_right {
          min-width: 2rem;
          text-align: center;
          font-weight: bold;
          font-size: 0.24rem;
          .ac {
            color: #ff410a;
          }
          span {
            font-size: 0.38rem;
            font-weight: bolder;
            margin: 0 0.05rem;
          }
        }
      }
      &.active {
        border: 1px solid #ff410a;
        background: #fee7d4;
        .item_left {
          border-right: 1px dashed #ff410a;
          .left_top {
            color: #ff410a;
          }
        }
        .item_right {
          color: #ff410a;
        }
      }
    }
  }
  .btn {
    position: fixed;
    bottom: 0.2rem;
    left: 0;
    right: 0;
    .ds {
      display: inline-block;
      background: rgba(0, 0, 0, 0.7);
      line-height: 0.5rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -0.65rem;
      color: #fff;
      border-radius: 0.1rem;
      padding: 0 0.2rem;
      font-size: 0.24rem;
      &::after {
        display: block;
        content: "";
        border-width: 4px 4px 4px 4px;
        border-style: solid;
        border-color: rgba(0, 0, 0, 0.7) transparent transparent transparent;
        /* 定位 */
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 100%;
      }
    }
    .sub {
      margin: 0 0.3rem;
      background: #ff410a;
      line-height: 0.8rem;
      border-radius: 0.4rem;
      color: #ffffff;
      text-align: center;
      font-size: 0.3rem;
      font-weight: bold;
      animation-name: likes; // 动画名称
      animation-direction: alternate; // 动画在奇数次（1、3、5...）正向播放，在偶数次（2、4、6...）反向播放。
      animation-timing-function: linear; // 动画执行方式，linear：匀速；ease：先慢再快后慢；ease-in：由慢速开始；ease-out：由慢速结束；ease-in-out：由慢速开始和结束；
      animation-delay: 0s; // 动画延迟时间
      animation-iteration-count: infinite; //  动画播放次数，infinite：一直播放
      animation-duration: 1.2s; // 动画完成时间
      span {
        margin: 0 0.05rem;
      }
    }
  }
}
@keyframes likes {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(0.95);
  }
  50% {
    transform: scale(0.9);
  }
  75% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
</style>
